import { useSelector } from "react-redux";

const useAuthorization = () => {
  const { modules } = useSelector((state) => state.loginSlice);
  function hasWritePermission(pathname) {
    const pathSegments = pathname.split("/");
    const path = pathSegments[pathSegments.length - 1];
    let result = false;

    // function search(array) {
    //   for (let item of array) {
    //     if (
    //       item.sModuleName.replace(/\s+/g, "").toLowerCase() ===
    //       path.toLowerCase()
    //     ) {
    //       result = item.bWrite;
    //       return true;
    //     }
    //     if (item.aChild && item.aChild.length > 0) {
    //       if (search(item.aChild)) {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // }

    // search(modules);
    return result;
  }
  return { hasWritePermission };
};

export default useAuthorization;
